import { toast } from 'sonner';

const toastMessage = (message, type) => {
  const text = message || "Oupsi, quelque chose s'est mal passé";
  switch (type) {
    case 'error':
    case 'failed':
    case 'fail':
      return toast.error(text);
    case 'success':
      return toast.success(text);
    case 'warning':
      return toast.warning(text);
    case 'loading':
    case 'pending':
      return toast.loading(text);
    case 'info':
    default:
      return toast.info(text);
  }
};

export default toastMessage;
